import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { M8Product } from 'services/production/types';

export const getCalculationComponents = async (): Promise<M8Product[]> => {
  const response = await customFetch(getM8AdminURL('getCalculationComponents'));

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return response.json();
};
